
// Anti-Theft Image Protection
document.addEventListener('DOMContentLoaded', function() {
  // Prevent context menu (right click) on all images and product media
  document.addEventListener('contextmenu', function(e) {
    if (e.target.tagName === 'IMG' || e.target.closest('.product__media') || e.target.closest('.product__media-item') || e.target.closest('.matching-item-card')) {
      e.preventDefault();
      return false;
    }
  }, false);

  // Prevent dragging images to desktop or folder
  document.addEventListener('dragstart', function(e) {
    if (e.target.tagName === 'IMG') {
      e.preventDefault();
      return false;
    }
  }, false);
});
